import { h, Component } from 'preact'
import Header from '../header'
import Table from '../table/Table'
import InputGroup from '../ui-components/InputGroup'
import Axios from 'axios'
import AlertComponent from '../ui-components/AlertComponent'
import Tooltip from '../ui-components/Tooltip'

type PermissionType = {
  custom: boolean,
  permission: boolean,
  role: string,
  title: string,
}

interface Props {
  permissions: Array<PermissionType>
}

interface State {
  primary: Array<PermissionType>,
  custom: Array<PermissionType>,
  isLoading: boolean,
  messageType: null | string
}

export class IdeationPermissions extends Component<Props, State> {
  constructor (props: Props) {
    super(props)

    let primary:Array<PermissionType> = []
    let custom:Array<PermissionType> = []

    props.permissions.forEach(permission => {
      if (permission.custom) {
        custom.push(permission)
      } else {
        primary.push(permission)
      }
    })

    this.state = {
      primary,
      custom,
      isLoading: false,
      messageType: null
    }

    this.updatePermission = this.updatePermission.bind(this)
    this.saveChanges = this.saveChanges.bind(this)
  }

  updatePermission (key: 'primary' | 'custom', idx: number, newValue: boolean) {
    const newList = this.state[key].concat([])
    newList[idx].permission = newValue
    // @ts-ignore
    this.setState({[key]: newList})
  }

  async saveChanges () {
    this.setState({ isLoading: true, messageType: null })
    try {
      await Axios.post('/platform/ideation/permissions', {
        permissions: this.state.primary.concat(this.state.custom)
      })
      this.setState({ isLoading: false, messageType: 'success' })
    } catch {
      this.setState({ isLoading: false, messageType: 'error' })
    }
  }

  render (_: Props, { primary, custom, isLoading, messageType }: State) {
    const primaryModel = [
      {
        header: 'Default role',
        accessor: 'role'
      },
      {
        header: <span>Access to ideation <Tooltip
          trigger={<i className='fa fa-question-circle' />}
          tooltipMessage='User can view, create, reply and vote for ideas'
          noWrap
        /></span>,
        accessor: 'action'
      }]

    const primaryRows = primary.map((permissionInfo, idx) => ({
      role: permissionInfo.title,
      action: <InputGroup
        type='checkbox'
        checked={permissionInfo.permission}
        onChangeCheckbox={() => this.updatePermission('primary', idx, !permissionInfo.permission)}
      />
    }))

    const customModel = [
      {
        header: 'Custom role',
        accessor: 'role'
      },
      {
        header: <span>Access to ideation <Tooltip
          trigger={<i className='fa fa-question-circle' />}
          tooltipMessage='User can view, create, reply and vote for ideas'
          noWrap
        /></span>,
        accessor: 'action'
      }]

    const customRows = custom.map((permissionInfo, idx) => ({
      role: permissionInfo.title,
      action: <InputGroup
        type='checkbox'
        checked={permissionInfo.permission}
        onChangeCheckbox={() => this.updatePermission('custom', idx, !permissionInfo.permission)}
      />
    }))

    return (
      <div className='ideation-platform-page'>
        <Header
          isLoading={isLoading}
          title='Permissions Settings'
          saveCallback={this.saveChanges}
          hasBreadcrumb
          breadcrumbText='Ideation'
          breadcrumbLink='/platform/ideation'
        />

        { messageType ? <AlertComponent sticky messageType={messageType} isVisibleFor={3000} /> : null }

        <Table model={primaryModel} rows={primaryRows} />

        {
          custom.length ? (
            <Table model={customModel} rows={customRows} />
          ) : null
        }
      </div>
    )
  }
}

export default IdeationPermissions
